<template>
  <div>
    <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        <div class="pt-3">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10" v-if="data != null">
              <div class="row headercontenido py-5 py-md-0 pb-md-2">
                <div class="col-lg-12">
                  <span class="titulo bold fG">Detalle Póliza</span>
                </div>
                <div class="col-lg-12" v-if="this.$store.state.user.user_level == 1">
                  <router-link
                    :to="'/proceso-endoso/' + id_registro"
                    class="submit btngris float-right"
                    @click="regresar()"
                  >
                    Generar endoso
                  </router-link>

                  <router-link
                    :to="'/renovacion/' + id_registro"
                    type="button"
                    class="submit btngris float-right mr-2"
                    v-if="data.renovacion_disponible"
                  >
                    Renovar
                  </router-link>

                  <!-- <router-link
                    class="submit btngris float-right mr-2"
                    :to="'/editar-registro/' + id_registro"
                    v-if="this.$store.state.user.user_level == 1"
                  >
                    Editar
                  </router-link> -->
                  <button
                    class="submit btngris float-right mr-2"
                    @click="preguntarBaja()"
                    v-if="
                      this.$store.state.user.id == 1 && data.status == 1
                    "
                  >
                    Dar de baja
                  </button>
                  <button
                    class="submit btngris float-right mr-2"
                    @click="preguntarAlta()"
                    v-if="
                      this.$store.state.user.id == 1 && data.status == 0
                    "
                  >
                    Dar de alta
                  </button>
                </div>
              </div>

              <div class="row headercontenido" v-if="data != null">
                <div class="col-12">
                  <div
                    class="
                      row
                      bg-white
                      rounded
                      no-gutters
                      shadow
                      p-4
                      justify-content-center
                      align-items-center
                      borderlight
                    "
                  >
                    <div class="col-8">
                      <span class="bold fM2 gris2">{{ data.contratante }}</span>
                    </div>
                    <div class="col-4">
                      <a
                        target="_blank"
                        title="Descargar PDF"
                        download
                        :href="
                          $store.state.baseurl +
                          'certificados/poliza-' +
                          data.no_certificado +
                          '.pdf'
                        "
                        class="btngrischico float-right ml-2"
                      >
                        <i class="fa fa-file-pdf fM2"></i>
                      </a>
                      <div
                        @click="toggleOverlay"
                        title="Enviar por correo"
                        class="pointer btngrischico float-right ml-2"
                      >
                        <i class="fas fa-envelope fM2"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div ref="main" class="contenido pt-4 fC" v-if="data != null">
                <div class="row">
                  <div class="col-md-4 text-left pb-4">
                    <div class="card h-100 border-round p-4 shadow gris2">
                      <div class="pb-5">
                        <div class="bold negro">
                          <i class="fas fa-info-circle fR"></i> Estatus póliza
                        </div>
                        <hr />
                        <div class="">
                          <span v-if="data.status == 1">
                            Estatus: <span class="verde">Activa</span>
                          </span>
                          <span v-if="data.status == 0">
                            Estatus: <span class="rojo">Baja</span>
                          </span>
                        </div>
                        <div>Registró: {{ data.operador }}</div>
                      </div>
                      <div class="pb-5">
                        <div class="bold negro">
                          <i class="fas fa-building fR "></i> Compañía que
                          contrata
                        </div>
                        <hr />
                        <div class="">{{ data.contratante }}</div>
                      </div>
                      <div class="pb-5">
                        <div class="bold negro">
                          <i class="fas fa-file-alt fR"></i> Datos del
                          contratante:
                        </div>
                        <hr />
                        <div class="small pb-4">
                          <div class="bold">Número de póliza:</div>
                          <div>{{ data.no_poliza }}</div>
                        </div>
                        <div class="small pb-4">
                          <div class="bold">Número de certificado:</div>
                          <div>{{ data.no_certificado }}</div>
                        </div>
                        <div class="small pb-4">
                          <div class="bold">Inicio de Vigencia:</div>
                          <div>{{ data.vigencia_ini }}</div>
                        </div>
                        <div class="small pb-4">
                          <div class="bold">Fin de Vigencia:</div>
                          <div>{{ data.vigencia_fin }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4 text-left pb-4">
                    <div class="card h-100 border-round p-4 shadow">
                      <div class="pb-5 gris2">
                        <div class="bold negro">
                          <i class="fas fa-user fR"></i> Datos del cliente
                        </div>
                        <hr />
                        <div
                          class="small pb-4"
                          v-if="data.usar_razon_social == 0"
                        >
                          <div class="bold">Nombre:</div>
                          <div>
                            {{
                              data.nombre +
                              " " +
                              data.apellido_paterno +
                              " " +
                              data.apellido_materno
                            }}
                          </div>
                        </div>
                        <div class="small pb-4" v-else>
                          <div class="bold">Razón Social:</div>
                          <div>{{ data.razon_social }}</div>
                        </div>
                        <div class="small pb-4">
                          <div class="bold">Correo Electrónico:</div>
                          <div>{{ data.email }}</div>
                        </div>
                        <div class="small pb-4">
                          <div class="bold">Teléfono:</div>
                          <div>{{ data.telefono }}</div>
                        </div>
                        <div class="small pb-4">
                          <div class="bold">Dirección:</div>
                          <div>
                            <span>{{
                              data.calle + ", No. ext " + data.no_ext + ", "
                            }}</span>
                            <span v-if="data.no_int != ''">{{
                              data.no_int + ", "
                            }}</span>
                            <span>{{ data.colonia_txt +
                              ", " }}</span>
                            <span>{{
                              data.municipio_o_del_txt +
                              ", " +
                              data.estado_txt +
                              ", CP. " +
                              data.cp
                            }}</span>
                          </div>
                        </div>
                        <div class="small pb-4">
                          <div class="bold">RFC:</div>
                          <div>{{ data.rfc }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4 text-left pb-4">
                    <div class="card h-100 border-round p-4 shadow gris2">
                      <div class="pb-5">
                        <div class="bold negro">
                          <i class="fas fa-shield-alt fR"></i> Datos de
                          cobertura
                        </div>
                        <hr />
                        <div class="small pb-4">
                          <div class="bold">Prima Neta:</div>
                          <div>{{ data.prima_neta_txt }}</div>
                        </div>
                        <div class="small pb-4">
                          <div class="bold">Derecho de Póliza:</div>
                          <div>{{ data.derecho_poliza_txt }}</div>
                        </div>
                        <div class="small pb-4">
                          <div class="bold">IVA:</div>
                          <div>{{ data.iva_txt }}</div>
                        </div>
                        <div class="small pb-4">
                          <div class="bold">Prima Total:</div>
                          <div>{{ data.prima_total_txt }}</div>
                        </div>
                        <div class="small pb-4">
                          <div class="bold">Cobertura Básica:</div>
                          <div>
                            Deducible: {{data.cobertura_basica}}% del valor de la bicicleta
                          </div>
                        </div>
                        <div class="small pb-4">
                          <div class="bold">Robo con Violencia:</div>
                          <div>
                            Deducible: 10% del valor de la bicicleta
                          </div>
                        </div>
                        <div class="small pb-4">
                          <div class="bold">Responsabilidad Civil:</div>
                          <div>
                           Deducible: 10% de la pérdida con mínimo de 50 UMAS
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 text-left pb-4 mb-2">
                    <div class="card h-100 border-round p-4 shadow gris2">
                      <div class="pb-5">
                        <div class="bold negro">
                          <i class="fas fa-bicycle fR"></i> Datos de la
                          bicicleta:
                        </div>
                        <hr />
                        <div class="d-flex">
                          <div class="small pb-4 w-100">
                            <div class="bold">Marca:</div>
                            <div>{{ data.marca }}</div>
                          </div>
                          <div class="small pb-4 w-100">
                            <div class="bold">No. de Serie:</div>
                            <div>{{ data.no_serie }}</div>
                          </div>
                          <div class="small pb-4 w-100">
                            <div class="bold">Equipamiento Adicional:</div>
                            <div>{{ data.equipamiento_adicional }}</div>
                          </div>
                          <div class="small pb-4 w-100">
                            <div class="bold">Valor Factura:</div>
                            <div>{{ data.valor_factura_txt }}</div>
                          </div>
                          <div class="small pb-4 w-100">
                            <div class="bold">Año:</div>
                            <div>{{ data.ano }}</div>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="small pb-4 w-100">
                            <div class="bold">Descripcion:</div>
                            <div>{{ data.descripcion }}</div>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-12 text-left pb-4 mb-5"
                    v-if="data.renovaciones != null"
                  >
                    <div class="card h-100 border-round p-4 shadow">
                      <div class="pb-5">
                        <div class="bold">
                          <i class="fas fa-history fR"></i> Historial de
                          renovaciones:
                        </div>
                        <hr />
                        <div
                          class="d-flex"
                          v-if="
                            data.renovaciones == null ||
                            data.renovaciones.length == 0
                          "
                        >
                          ...
                        </div>
                        <div v-else>
                          <v-client-table
                            :columns="columns"
                            v-model="data.renovaciones"
                            :options="options"
                          >
                            <router-link
                              slot="uri"
                              slot-scope="props"
                              :to="'/registro/' + props.row.id"
                              class="text-center negro"
                            >
                              <i class="fas fa-eye"></i> Ver
                            </router-link>

                            <div
                              slot="name"
                              slot-scope="{
                                row,
                                update,
                                setEditing,
                                isEditing,
                                revertValue,
                              }"
                            >
                              <span
                                @click="setEditing(true)"
                                v-if="!isEditing()"
                              >
                                <a>{{ row.name }}</a>
                              </span>
                              <span v-else>
                                <input type="text" v-model="row.name" />
                                <button
                                  type="button"
                                  class="btn btn-info btn-xs"
                                  @click="
                                    update(row.name);
                                    setEditing(false);
                                  "
                                >
                                  Submit
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-default btn-xs"
                                  @click="
                                    revertValue();
                                    setEditing(false);
                                  "
                                >
                                  Cancel
                                </button>
                              </span>
                            </div>
                          </v-client-table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-12 text-left pb-4 mb-5"
                    v-if="data.endosos != null"
                  >
                    <div class="card h-100 border-round p-4 shadow">
                      <div class="pb-5">
                        <div class="bold">
                          <i class="fas fa-history fR"></i> Historial de endosos:
                        </div>
                        <hr />
                        <div
                          class="d-flex"
                          v-if="
                            data.endosos == null || data.endosos.length == 0
                          "
                        >
                          ...
                        </div>
                        <div v-else>
                          <v-client-table
                            :columns="columns_endosos"
                            v-model="data.endosos"
                            :options="options_endosos"
                          >

                          <a slot="status" slot-scope="props">
                            <span v-if="props.row.status == 1">Activo</span>
                            <span class="rojo" v-if="props.row.status == 0"
                              >Baja</span
                            >
                          </a>


                            <router-link
                              slot="uri"
                              slot-scope="props"
                              :to="'/endoso/' + props.row.id"
                              class="text-center negro"
                            >
                              <i class="fas fa-eye"></i> Ver
                            </router-link>

                            <div
                              slot="name"
                              slot-scope="{
                                row,
                                update,
                                setEditing,
                                isEditing,
                                revertValue,
                              }"
                            >
                              <span
                                @click="setEditing(true)"
                                v-if="!isEditing()"
                              >
                                <a>{{ row.name }}</a>
                              </span>
                              <span v-else>
                                <input type="text" v-model="row.name" />
                                <button
                                  type="button"
                                  class="btn btn-info btn-xs"
                                  @click="
                                    update(row.name);
                                    setEditing(false);
                                  "
                                >
                                  Submit
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-default btn-xs"
                                  @click="
                                    revertValue();
                                    setEditing(false);
                                  "
                                >
                                  Cancel
                                </button>
                              </span>
                            </div>
                          </v-client-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
    </span>

    <div class="overlay" v-if="showOverlay">
      <div class="overlaybg" @click="toggleOverlay"></div>
      <div class="overlayinfo">
        <div class="cont container">
          <div class="row card bg-white shadow round">
            <div class="btnclose" @click="toggleOverlay">
              <i class="fa fa-times"></i>
            </div>

            <div class="col-12 p-4">
              <h2>Enviar certificado por correo</h2>
              <hr />
              <form
                class="formulario"
                action=""
                @submit="submitEnvioCorreo($event)"
              >
                <label>
                  <span>Correo electrónico</span>
                  <input type="email" v-model="formcorreo.email" required />
                </label>
                <label>
                  <button class="btn btngris" type="submit">Enviar</button>
                </label>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";
import Menu from "../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "GAIG",
  props: {
    msg: String,
  },
  data() {
    return {
      showOverlay: false,
      id_registro: null,
      paso: 5,
      formcorreo: {
        email: "",
      },
      form: {
        contratante: "",
        no_poliza: "",
        no_certificado: "",
        vigencia_ini: "",
        vigencia_fin: "",
        usar_razon_social: false,
        razon_social: "",
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        rfc: "",
        email: "",
        email2: "",
        telefono: "",
        ciudad: "",
        municipio_o_del: "",
        colonia: "",
        cp: "",
        calle: "",
        no_ext: "",
        no_int: "",
        marca: "",
        modelo: "",
        no_serie: "",
        equipamiento_adicional: "",
        valor_factura: "",
        ano: "",
      },
      tiposervicio: "",
      columns: [
        "uri",
        "timestamp",
        "contratante",
        "email",
        "no_poliza",
        "no_certificado",
        
        // "baja",
        // "bloqueo"
      ],
      columns_endosos: [
        "uri",
        "timestamp",
        "no_endoso",
        "fecha_ini_endoso",
        "fecha_fin_endoso",
        "equipamiento_adicional",
        "dias_endoso",
        "endoso",
        "valor_factura",
        "status"
        // "baja",
        // "bloqueo"
      ],
      datos: null,
      data: null,
      options: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          timestamp: "Fecha",
          nombre: "Nombre",
          email: "Email",
          no_poliza: "No. de póliza",
          no_certificado: "No. de certificado",
          uri: "Detalle",
          baja: "Baja",
          bloqueo: "Bloqueo",
        },
        editableColumns: ["name"],
        sortable: [],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed",
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Buscar registro",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },
      options_endosos: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          timestamp: "Fecha",
          no_endoso: "No. Endoso",
          fecha_ini_endoso: "Fecha Inicio",
          fecha_fin_endoso: "Fecha Fin",
          dias_endoso: "Días",
          endoso: "Valor Endoso",
          uri: "Detalle",
          baja: "Baja",
          bloqueo: "Bloqueo",
        },
        editableColumns: ["name"],
        sortable: [],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed",
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Buscar endoso",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu,
  },
  mounted: function () {
    this.init();
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      this.init();
    },
  },
  methods: {
    init() {
      this.$nextTick(() => (this.$refs.main.scrollTop = 0));

      this.$store.state.user = JSON.parse(this.$cookie.get("usergaig"));
      AOS.init();

      this.id_registro = this.$route.params.id;
      this.consulta();
      this.getCoberturaBasica();
    },
    preguntarBaja() {
      swal
        .fire({
          title: "Baja de registro",
          html: "¿Dar de baja este registro?",
          confirmButtonText: `Ok`,
          showCancelButton: true,
          focusConfirm: false,
          cancelButtonText: "Cancelar",
          icon: "warning",
        })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.baja();
          }
        });
    },
    baja() {
      // proceso de baja

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id_registro: this.id_registro,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "baja-registro.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");

              window.location.reload();
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    preguntarAlta() {
      swal
        .fire({
          title: "Alta de registro",
          html: "¿Dar de alta este registro?",
          confirmButtonText: `Ok`,
          showCancelButton: true,
          focusConfirm: false,
          cancelButtonText: "Cancelar",
          icon: "warning",
        })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.alta();
          }
        });
    },
    alta() {
      // proceso de alta

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id_registro: this.id_registro,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "realta-registro.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");

              window.location.reload();
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    consulta() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id: this.id_registro,
        admin_id: this.$store.state.user.admin_id,
        user_id: this.$store.state.user.id
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-registro.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.data = res.datos[0];
              this.data.renovaciones = res.renovaciones;
              this.data.endosos = res.endosos;
              this.data.renovacion_disponible = res.renovacion_disponible;

              console.log({data: this.data})
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    razonSocialChange(e) {
      if (!this.form.usar_razon_social) {
        this.form.razon_social = "";
      } else {
        this.form.nombre = "";
        this.form.apellido_paterno = "";
        this.form.apellido_materno = "";
      }
    },
    continuar() {
      this.paso++;
    },
    regresar() {
      this.paso--;
    },
    terminar() {
      //terminar
    },
    submitEnvioCorreo(e) {
      e.preventDefault();

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        email: this.formcorreo.email,
        id: this.id_registro,
        admin_id: this.$store.state.user.admin_id
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "reenvio-certificado.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");

              this.toggleOverlay();

              swal
                .fire({
                  title: "Envío certificado",
                  html: res.msg,
                  confirmButtonText: `Ok`,
                  icon: "success",
                })
                .then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    //this.$router.push("/dashboard");
                  }
                });
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    toggleOverlay() {
      this.showOverlay = !this.showOverlay;
    },
    getCoberturaBasica() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        admin_id: this.$store.state.user.admin_id
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "get-cobertura-basica.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.form.cobertura_basica = res.cobertura_basica;
             
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
  },
};
</script>

